angular.module('picmonicng').directive('plsMenuFact', [
  function () {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: '/templates/directives/pls-menu-fact.html',
      controller: [
        '$scope',
        '$state',
        'PermissionsService',
        'LearnService',
        'UserService',
        '$modal',
        'toaster',
        'FactsResource',
        function ($scope, $state, PermissionsService, LearnService, UserService, $modal, toaster, FactsResource) {
          $scope.LearnService = LearnService;
          $scope.PermissionsService = PermissionsService;
          $scope.UserService = UserService;

          $scope.reportError = function (fact) {
            if (LearnService.currentCard.entity_type_id == 1) {
              openUGCComment();
            } else {
              openFalseBountyFor(fact);
            }
          };

          function openUGCComment() {
            $modal.open({
              templateUrl: '/templates/modals/learn-ugc-disclaimer.html',
              controller: [
                '$scope',
                '$document',
                function ($scope, $document) {
                  $scope.reportError = true;
                  $scope.comment = function () {
                    $scope.$close();
                    $document.scrollTopAnimated(0).then(function () {
                      LearnService.rightSidebarOpen = true;
                      LearnService.toggleComments();
                    });
                  };
                },
              ],
            });
          }

          function openFalseBountyFor(fact) {
            $modal.open({
              templateUrl: '/templates/modals/false-bounty.html',
              controller: [
                '$scope',
                'FalseBountyResource',
                'toaster',
                '$timeout',
                'XpService',
                function ($scope, FalseBountyResource, toaster, $timeout, XpService) {
                  $scope.questions = { fact_id: fact.fact_id, severity: '' };
                  $scope.complete = false;
                  $scope.setQuestion = function (type, $event) {
                    $scope.questions.type = type;
                    $scope.questions.location = '';
                    $scope.questions.error = '';
                  };

                  $scope.submit = function () {
                    if (!$scope.loading) {
                      if (!$scope.questions.type || !$scope.questions.location || !$scope.questions.error) {
                        $scope.error_msg = 'Please Fill out all Fields.';
                        return false;
                      }
                      $scope.error_msg = false;
                      $scope.loading = true;
                      FalseBountyResource.save($scope.questions)
                        .$promise.then(function (result) {
                          XpService.grant(
                            'FalseBounty',
                            result.false_bounty_id,
                            angular.element('.false-bounty-complete-button')
                          );
                        })
                        .finally(function () {
                          $scope.loading = false;
                          $scope.complete = true;
                        });
                    }
                  };
                },
              ],
            });
          }

          $scope.deleteFact = function (fact) {
            $modal.open({
              templateUrl: '/templates/modals/delete-confirm.html',
              windowClass: 'below-nav learn-master-complete',
              backdropClass: 'below-nav',
              size: 'sm',
              controller: [
                '$scope',
                '$modalInstance',
                function ($scope, $modalInstance) {
                  $scope.confirmation_text = 'Are you sure you want to delete this fact?';

                  $scope.confirm = function () {
                    $scope.loading = true;
                    FactsResource.delete({ card_id: fact.card_id, fact_id: fact.fact_id }, function () {
                      LearnService.currentFacts = _.without(LearnService.currentFacts, fact);
                      $modalInstance.close();
                    });
                  };

                  $scope.cancel = function () {
                    $modalInstance.close();
                  };
                },
              ],
            });
          };

          $scope.downloadCharacter = function (fact) {
            window.location = '/api/v2/facts/' + fact.fact_id + '/download_character';
          };

          $scope.googleImageSearch = function (fact) {
            window.open('https://www.google.com/search?tbm=isch&q=' + encodeURIComponent(fact.name));
          };

          $scope.wikipediaSearch = function (fact) {
            window.open('https://en.wikipedia.org/wiki/' + encodeURIComponent(fact.name));
          };

          $scope.editFact = function (fact) {
            $state.go('app.editor', {
              slug: LearnService.currentCard.slug,
              tab: 'fact',
              selectedFactId: fact.fact_id,
            });
          };
        },
      ],
    };
  },
]);
